"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var jsx_runtime_1 = require("@emotion/react/jsx-runtime");

var Icon = function Icon() {
  return (0, jsx_runtime_1.jsxs)("svg", {
    width: "100%",
    height: "100%",
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: [(0, jsx_runtime_1.jsx)("path", {
      d: "M12.0337 2.55259C13.3665 1.16261 15.5737 1.11626 16.9637 2.44906C18.3537 3.78186 18.4 5.9891 17.0672 7.37908",
      stroke: "currentColor",
      strokeWidth: "1.2"
    }), (0, jsx_runtime_1.jsx)("path", {
      d: "M4.79343 10.1029C6.12623 8.71291 8.33348 8.66655 9.72346 9.99935C11.1134 11.3322 11.1598 13.5394 9.82699 14.9294",
      stroke: "currentColor",
      strokeWidth: "1.2"
    }), (0, jsx_runtime_1.jsx)("path", {
      d: "M7.20554 7.58628C8.53834 6.1963 10.7456 6.14995 12.1356 7.48275C13.5255 8.81555 13.5719 11.0228 12.2391 12.4128",
      stroke: "currentColor",
      strokeWidth: "1.2"
    }), (0, jsx_runtime_1.jsx)("path", {
      d: "M9.61961 5.06919C10.9524 3.67921 13.1597 3.63286 14.5496 4.96566C15.9396 6.29846 15.986 8.50571 14.6532 9.89568",
      stroke: "currentColor",
      strokeWidth: "1.2"
    }), (0, jsx_runtime_1.jsx)("path", {
      d: "M2.41453 12.5843C3.74733 11.1944 5.95457 11.148 7.34455 12.4808C8.73453 13.8136 8.78088 16.0208 7.44808 17.4108",
      stroke: "currentColor",
      strokeWidth: "1.2"
    }), (0, jsx_runtime_1.jsx)("path", {
      d: "M2.41485 12.5845C1.08205 13.9744 1.1284 16.1817 2.51838 17.5145C3.90836 18.8473 6.1156 18.8009 7.4484 17.411",
      stroke: "currentColor",
      strokeWidth: "1.2"
    }), (0, jsx_runtime_1.jsx)("path", {
      d: "M17.1016 7.34375L7.44858 17.4109M2.41502 12.5844L12.068 2.51726",
      stroke: "currentColor",
      strokeWidth: "1.2"
    }), (0, jsx_runtime_1.jsx)("line", {
      x1: "7.2348",
      y1: "12.3761",
      x2: "16.8878",
      y2: "2.30901",
      stroke: "currentColor"
    })]
  });
};

exports.default = Icon;